import React from "react";
import Reset from "../features/auth/components/Reset";

function ResetPassword() {
  return <Reset />;
}

export default ResetPassword;
